<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        Editando Cadastro
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>
  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card style='width: 500px; margin: auto;'>

    <div style="padding: 10px 0 0px 0; ">
      <b>{{memberForm.controls.name.value}}</b>
    </div>

    <form [formGroup]="memberForm">

      <div style="font-size: 11px; color: rgba(0,0,0, .7);">Categoria</div>
      <div style="padding-bottom: 2px; margin-bottom: 30px; border-bottom: solid 1px gray;">
        {{_frontDeskService.currentMember.subCategory.name}}
      </div>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome no Crachá</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.shortName"
          autocomplete="off">
        <mat-error *ngIf="memberForm.controls.shortName.hasError('required')">
          O nome no crachá é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.email"
          autocomplete="off">
        <mat-error *ngIf="memberForm.controls.email.hasError('required')">
          O email é obrigatório
        </mat-error>
      </mat-form-field>

      <div style="display: flex; flex-direction:row; justify-content: space-between;">

        <mat-form-field class="field-width" appearance="outline">
          <mat-label>Celular</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cellPhone"
            autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cellPhone.hasError('required')">
            O celular é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="crm-width" appearance="outline">
          <mat-label>CRM</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.crm"
            autocomplete="off">
        </mat-form-field>

      </div>

      <div style="display: flex; flex-direction:row; justify-content: space-between;">

        <mat-form-field class="field-width" appearance="outline">
          <mat-label>Documento</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cpf"
            autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cpf.hasError('required')">
            O documento é obrigatório
          </mat-error>
        </mat-form-field>

        <div style="height: 50px;">
          <button mat-raised-button (click)='updateMember()' [disabled]="memberForm.invalid" class='button-class'
            style='font-size: 14px; margin: 10px 10px 0 0;'>
            <mat-icon style="color: white;">check_circle_outline</mat-icon>
          </button>
        </div>

      </div>

    </form>

    <button mat-raised-button (click)='getSubscriptions()' [disabled]="!_frontDeskService.currentMember.cpf"
      class="button-class" style='margin-top: 20px;'>
      INSCRIÇÕES
    </button>

  </mat-card>

</div>